/**
 * BOTTOM GENERAL INITS
 */

import { TvScheduleTabs } from "./tvScheduleTabs";
import { TvScheduleSlider } from "./tvScheduleSlider";
import { TvScheduleBar } from "./tvScheduleBar";
import { TvScheduleNavigationDropdown } from "./tvScheduleNavigationDropdown";


export class TvScheduleInits {
    scheduleTv = {
        tvScheduleSection: ".tv-schedule__section",
        tvScheduleBar: ".tv-schedule-bar"
    };

    constructor() {
        this.initMap();
    }

    initMap() {
        if ($(this.scheduleTv.tvScheduleSection).length) {
            new TvScheduleTabs(this.scheduleTv.tvScheduleSection);
            new TvScheduleNavigationDropdown();
            new TvScheduleSlider(this.scheduleTv.tvScheduleSection);
        }

        if ($(this.scheduleTv.tvScheduleBar).length) {
            new TvScheduleBar(this.scheduleTv.tvScheduleBar);
        }
    }
}
